/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {ParagraphDefault, ParagraphSmall, ParagraphAdditional, ParagraphModifiers, ParagraphRegressionTests} from 'Docs/uilib/elements/paragraph/Examples';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h2: "h2",
    p: "p",
    strong: "strong",
    ul: "ul",
    li: "li",
    code: "code",
    h3: "h3",
    pre: "pre",
    h4: "h4",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Paragraph"
    }), "\n", _jsx(_components.h2, {
      children: "Paragraph class modifiers"
    }), "\n", _jsx(_components.p, {
      children: "Eufemia comes with several styles you can use on paragraphs and other HTML text elements:"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Weights"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: ".dnb-p"
        }), " (Body text)"]
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: ".dnb-p--medium"
        })
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Sizes"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: ".dnb-p--small"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: ".dnb-p--x-small"
        })
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Variants"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: ".dnb-p--lead"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Paragraphs in React"
    }), "\n", _jsx(_components.p, {
      children: "Paragraphs using React JSX."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { P, Lead } from '@dnb/eufemia'\n"
      })
    }), "\n", _jsx(ParagraphModifiers, {}), "\n", _jsxs(_components.h3, {
      children: ["Paragraphs ", _jsx(_components.code, {
        children: "basis"
      }), " sized"]
    }), "\n", _jsx(ParagraphDefault, {}), "\n", _jsxs(_components.h4, {
      children: ["Paragraph ", _jsx(_components.code, {
        children: "small"
      }), " sized"]
    }), "\n", _jsx(ParagraphSmall, {}), "\n", _jsx(_components.h4, {
      children: "Additional Paragraph formatting (not defined yet)"
    }), "\n", _jsx(ParagraphAdditional, {}), "\n", _jsxs(_components.p, {
      children: ["Read more ", _jsx(_components.a, {
        href: "/quickguide-designer/fonts/",
        children: "about Fonts in the Designer Guides"
      }), "."]
    }), "\n", _jsx(ParagraphRegressionTests, {})]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
